import { useEffect, useState } from "react";
import coolCSS from "./NavBar.module.css";
import { MoonStars, Sun } from 'phosphor-react';

function ThemeToggle() {
    const [theme, setThemeState] = useState(() => {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) return savedTheme;
        const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        return systemPrefersDark ? "dark" : "light";
    });


    useEffect(() => {
        document.body.setAttribute("data-theme", theme);
    }, [theme]);

    const toggle = () => {
        const next = theme === "light" ? "dark" : "light";
        localStorage.setItem("theme", next);
        setThemeState(next);
    };

    return (
        <button onClick={toggle} className={`${coolCSS.coolButton} ${coolCSS.themeToggle}`}>
            {theme === "dark" ? <Sun weight="fill" className={coolCSS.icons} /> : <MoonStars weight="fill" className={coolCSS.icons} />}
            <span>{theme === "dark" ? "Light Mode" : "Dark Mode"}</span>
        </button>
    );
}

export default ThemeToggle;
